###*
@ngdoc service
@name kareo.ui.shared.assets:featureSet
@description Long term feature toggles
## Usage
```js
featureSet.load()
.then(function(){
    featureSet.hasDocuments()
}
```
*###
angular.module("kareo.ui.shared.modules.featureSet", ['kareo.ui.shared.modules.data'])
.service "featureSet", ['practiceFeaturesRepository', (practiceFeaturesRepository) ->
  featureSet = {}
  ###*
  @ngdoc
  @name #load
  @methodOf kareo.ui.shared.assets:featureSet
  @description
  Async load of features.  Results cached
  @returns {object} resolve with featureSet hash of enabled features
  *###
  load = ->
    practiceFeaturesRepository.get()
    .then (data) ->
      featureSet = data

  hasDocuments = ->
    !featureSet['feature-config.exclude-documents']

  hasClinicalFeatures = ->
    !!featureSet['feature-set.clinical']

  #Ability to toggle the product ehr, not whether they have it
  hasEhrProductAccess = ->
    !!featureSet['product-access.kareo-ehr']

  #Not sure if this is used
  #Also this is product access not the actual features
  #Todo Investigate
  hasOfficeFeatures = ->
    !!featureSet['product-access.kareo-office']

  hasAppointmentReminders = ->
    !!featureSet['kareo-office.appointment-reminders']

  hasSolutionCenterEnabled = ->
    !!featureSet['feature-set.solution-center']

  #ideally we wouldn't have temporary feature toggles on this 'public' interface

  isProductSwitchboardEnabled = ->
    !!featureSet['dark-feature.product-switchboard']

  isBillingWorkFlowEnabled = ->
    !!featureSet['feature-set.billing-workflow']



  ###*
  @ngdoc
  @name featureSet#
  @propertyOf kareo.ui.shared.assets:featureSet
  @description
  - `hasDocuments()`
  - `hasClinicalFeatures()`
  - `hasEhrProductAccess()`
  - `hasAppointmentReminders()`
  - `hasOfficeFeatures()`
  - `hasPracticeHealth()`
  - `isProductSwitchboardEnabled()`
  *###
  return {
    hasDocuments
    hasClinicalFeatures
    hasEhrProductAccess
    hasAppointmentReminders
    hasOfficeFeatures
    hasSolutionCenterEnabled
    isProductSwitchboardEnabled
    isBillingWorkFlowEnabled
    load
    features: -> featureSet
  }

]
